
import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import StepFormLayout from './containers/Form';

export default function StepLayout() {
  return <Router>
    <PrivateRoute path={["/cms/rewards/:id/steps/add", "/cms/rewards/:id/steps/:stepId"]} component={StepFormLayout} />
  </Router>
}

